/*
 * Public API Surface of ngx-mat-intl-tel-input
 */

export * from './lib/ngx-mat-intl-tel-input.component';
